import { createSelector } from 'reselect';

import getAllDocumentTransforms from './getDocumentTransforms';
import getAllFinishTransforms from './getFinishTransforms';

const getAllTransforms = createSelector(
    [getAllDocumentTransforms, getAllFinishTransforms],
    (docXforms, finishXforms) => [...docXforms, ...finishXforms],
);

export default getAllTransforms;
